import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import App from './App.vue';
import router from './router';
import store from './store';
import util from './common/util.js';
import osg from './common/common.js';
import date from './common/date.js';
import './resources/css/common.css';
import cFilter from './components/filter.vue';
import cForm from './components/form.vue';
import cTable from './components/table.vue';
import cModify from './components/modify.vue';
import cEditor from './components/editor.vue';
import cChat from './components/chat.vue';
import reportFilter from './components/reportFilter.vue';
import draggable from 'vuedraggable';

/* 富文本编辑器 */
import VueQuillEditor from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

import { Quill } from 'vue-quill-editor';
// 自定义插入a链接
var Link = Quill.import('formats/link');
class FileBlot extends Link {
  // 继承Link Blot
  static create(value) {
    let node = undefined;
    if (value && !value.href) {
      // 适应原本的Link Blot
      node = super.create(value);
    } else {
      // 自定义Link Blot
      node = super.create(value.href);
      // node.setAttribute('download', value.innerText);  // 左键点击即下载
      node.innerText = value.innerText;
      node.download = value.innerText;
    }
    return node;
  }
}
FileBlot.blotName = 'link';
FileBlot.tagName = 'A';
Quill.register(FileBlot);

// import * as Quill from 'quill';
// import ImageDrop from 'quill-image-drop-module';
// import ImageResize from 'quill-image-resize-module';
// Quill.register('modules/imageDrop', ImageDrop);
// Quill.register('modules/imageResize', ImageResize);

//生成二维码
import QRCode from 'qrcodejs2';
Vue.prototype.$qrCode = QRCode;

/* 引入图标库font-awesome */
import '@fortawesome/fontawesome-free/css/all.min.css';

// 引入插件-复制内容至剪切板
import VueClipboard from 'vue-clipboard2';

VueClipboard.config.autoSetContainer = true; // 自动设置container
Vue.use(VueClipboard);

Vue.prototype.$util = util.util;
Vue.prototype.osg = osg.osg;
Vue.prototype.date = date.date;

Vue.use(ElementUI, {
  size: 'small',
  zIndex: 3000
});
Vue.use(VueQuillEditor);
Vue.component('c-filter', cFilter);
Vue.component('c-form', cForm);
Vue.component('c-table', cTable);
Vue.component('c-modify', cModify);
Vue.component('c-editor', cEditor);
Vue.component('c-chat', cChat);
Vue.component('report-filter', reportFilter);
Vue.component('draggable', draggable);

// iconPark图标库
import { IconPark } from '@icon-park/vue/es/all';
Vue.component('icon-park', IconPark);

Vue.config.productionTip = false;

/**
 * 按钮权限指令
 * inserted：被绑定元素插入父节点时调用
 */
Vue.directive('has', {
  inserted: function(el, binding) {
    if (!Vue.prototype.$_has(binding.value)) {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  }
});
//按钮权限检查方法
Vue.prototype.$_has = function(value) {
  if (JSON.parse(sessionStorage['buttons'])[value.split(',')[0]]) {
    // 有这个菜单权限
    if (
      JSON.parse(sessionStorage['buttons'])[value.split(',')[0]].indexOf(value.split(',')[1]) != -1
    ) {
      // 有这个菜单下的按钮或标签页
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

//金额保留两位小数、千分位格式
Vue.filter('toMoney', function(val) {
  if (!val) {
    return 0;
  } else {
    val = Number(val).toFixed(2);
    let reg = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g;
    return val.toString().replace(reg, '$1,');
  }
});
// 格式化JSON组件
import JsonViewer from 'vue-json-viewer';
Vue.use(JsonViewer);

//格式化代码组件-代码对比
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
Vue.use(codemirror);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

// router.afterEach(() => {
//   setTimeout(() => {
//     // 百度统计
//     var _hmt = _hmt || [];
//     (function() {
//       //每次执行前，先移除上次插入的代码
//       document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
//       var hm = document.createElement('script');
//       hm.src = 'https://hm.baidu.com/hm.js?027c7e25f566911dc0af390cac8f4fc8';
//       hm.id = 'baidu_tj';
//       var s = document.getElementsByTagName('script')[0];
//       s.parentNode.insertBefore(hm, s);
//     })();
//   }, 0);
// });
